var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HTTPError } from "../arusha/consent.js";
//
export function getCompanyStatus(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId), {
            method: "GET",
        });
        if (!res.ok) {
            throw new HTTPError(res.status, { message: "not found", res: res });
        }
        return (yield res.json());
    });
}
export function subscribeCompany(ctx, companyId) {
    return __awaiter(this, void 0, void 0, function* () {
        const res = yield ctx.fetch(ctx.url.joinPath("/v1/company", companyId, "subscribe"), {
            method: "POST",
        });
        if (!res.ok) {
            throw new Error("Failed to subscribe company");
        }
        return (yield res.json());
    });
}
